import { render } from "./AssignmentChangeActivityBadge.vue?vue&type=template&id=4fafa3c8&scoped=true"
import script from "./AssignmentChangeActivityBadge.vue?vue&type=script&lang=js"
export * from "./AssignmentChangeActivityBadge.vue?vue&type=script&lang=js"

import "./AssignmentChangeActivityBadge.vue?vue&type=style&index=0&id=4fafa3c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4fafa3c8"

export default script